export default __webpack_public_path__ + "static/media/arrow-narrow-down.93b1af71.svg";